import { render, staticRenderFns } from "./IndexHub.vue?vue&type=template&id=b0af98ae&"
import script from "./IndexHub.vue?vue&type=script&lang=js&"
export * from "./IndexHub.vue?vue&type=script&lang=js&"
import style0 from "./IndexHub.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0af98ae')) {
      api.createRecord('b0af98ae', component.options)
    } else {
      api.reload('b0af98ae', component.options)
    }
    module.hot.accept("./IndexHub.vue?vue&type=template&id=b0af98ae&", function () {
      api.rerender('b0af98ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Listing/Pages/IndexHub.vue"
export default component.exports